import React, { useState } from "react";
import { Link } from "@reach/router";
import { auth, generateUserDocument } from "../firebase";
import Select from 'react-select';
import MultiSelect from "react-multi-select-component";
import Spinner from 'react-bootstrap/Spinner'


const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [dietaryPref, setDietaryPref] = useState([]);
  const [allergies, setAllergies] = useState("");
  const [error, setError] = useState(null);

  const [submitting, setSubmitting] = useState(false);


  const createUserWithEmailAndPasswordHandler = async (event, email, password) => {
    event.preventDefault();
    try{

      let apiResponse = "";
      const url = "https://us-central1-graceful-splice-319504.cloudfunctions.net/fima-initial";
      
      const data = {
        "allergies": allergies ? allergies : '[]',
        "preferences": dietaryPref.toString(),
        "user": "this-is-will",
        "test": "will-1251"
      };

      await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': '*'
          },
          body: JSON.stringify(data),
        }).then(response => response.text()).then(json => {
          apiResponse = JSON.stringify(json);
        })
        .catch(error => console.error('Error:', error));

      const recipeIds = apiResponse.replace("\"", "").replace("\"", "").split(",");

      const liked = [];
      const disliked = [];
      const {user} = await auth.createUserWithEmailAndPassword(email, password);
      generateUserDocument(user, {displayName, allergies, dietaryPref, recipeIds, liked, disliked});
    }
    catch(error){
      setError('Error Signing up with email and password');
    }
      
    setEmail("");
    setPassword("");
    setDisplayName("");
    setDietaryPref([]);
    setAllergies("");
  };

  const onChangeHandler = event => {
    const { name, value } = event.currentTarget;

    if (name === "userEmail") {
      setEmail(value);
    } else if (name === "userPassword") {
      setPassword(value);
    } else if (name === "displayName") {
      setDisplayName(value);
    } else if (name === "allergy") {
      setAllergies(value);
    }
  };

  const onMultiSelectChange = (value) => {
    console.log(value);
    console.log(value.map(i => i.value));
    setDietaryPref(value.map(i => i.value));
  }

  const options = [
    { value: '[]', label: 'No Preferences' },
    { value: 'gluten-free', label: 'Gluten Free' },
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'vegan', label: 'Vegan' },
    { value: 'dairy-free', label: 'Dairy Free' },
    { value: 'low-carb', label: 'Low Carb' },
    { value: 'very-low-carbs', label: 'Very Low Carbs' },
    { value: 'lactose', label: 'Lactose' },
    { value: 'fish', label: 'Fish' },
    { value: 'low-sodium', label: 'Low Sodium' },
    { value: 'low-calorie', label: 'Low Calorie' },
    { value: 'low-cholesterol', label: 'Low Cholesterol' },
    { value: 'low-protein', label: 'Low Protein' },
    { value: 'low-fat', label: 'Low Fat' },
    { value: 'high-calcium', label: 'High Calcium' },
    { value: 'easy', label: 'Easy' },
    { value: '5-ingredients-or-less', label: '5 Ingredients or Less' },
    { value: '3-steps-or-less', label: '3 Steps or Less' },
    { value: '15-minutes-or-less', label: '15 Minutes or Less' },
    { value: '30-minutes-or-less', label: '30 Minutes or Less'}
     ]

  const allergy_options = [
    { value: 'soybean', label: 'Soybean' },
    { value: 'peanuts', label: 'Peanuts' },
    { value: 'milk', label: 'Milk' },
    { value: 'wheat', label: 'Wheat' },
    { value: 'eggs', label: 'Eggs' },
    { value: 'fish', label: 'Fish' },
    { value: 'shellfish', label: 'Shellfish' },
    { value: 'tree_nuts', label: 'Tree Nuts' },
    { value: 'no_allergies', label: 'No Allergies' }]

  return (
    <div className="mt-8">
      <h1 className="text-3xl mb-2 text-center font-bold">Sign Up</h1>
      <div className="border border-red-400 mx-auto w-11/12 md:w-2/4 rounded py-8 px-4 md:px-8 " style={{backgroundColor: "#FFFFFF"}}>
        {error !== null && (
          <div className="py-4 bg-red-600 w-full text-white text-center mb-3">
            {error}
          </div>
        )}
        <form className="">
          <label htmlFor="displayName" className="block">
            Display Name:
          </label>
          <input
            type="text"
            className="my-1 p-1 w-full "
            name="displayName"
            value={displayName}
            placeholder="Berkeley student"
            id="displayName"
            onChange={event => onChangeHandler(event)}
          />
          <label htmlFor="userEmail" className="block">
            Email:
          </label>
          <input
            type="email"
            className="my-1 p-1 w-full"
            name="userEmail"
            value={email}
            placeholder="mids@ischool.berkeley.edu"
            id="userEmail"
            onChange={event => onChangeHandler(event)}
          />
          <label htmlFor="userPassword" className="block">
            Password:
          </label>
          <input
            type="password"
            className="mt-1 mb-3 p-1 w-full"
            name="userPassword"
            value={password}
            placeholder="Your Password"
            id="userPassword"
            onChange={event => onChangeHandler(event)}
          />
          <label htmlFor="diet">
            Dietary Preferences:
          </label>
          <MultiSelect
              name="dietaryPref"
              id="dietaryPref"
              options={options}
              value={dietaryPref.map( i => { return ({value: i, label: i})})}
              onChange={onMultiSelectChange}
          />
          <br />
          <label htmlFor="allergy">
            Allergies:
          </label>
          <input
            type="allergy"
            className="mt-1 mb-3 p-1 w-full"
            name="allergy"
            value={allergies}
            placeholder="Enter allergies, separated by a comma"
            id="allergy"
            onChange={event => onChangeHandler(event)}
          />
          <br />

          <button
            className="bg-green-400 hover:bg-green-500 w-full py-2 text-white"
            onClick={event => {
              createUserWithEmailAndPasswordHandler(event, email, password);
            }}
          >
            Sign up
          </button>
        </form>
        <p className="text-center my-3">
          Already have an account?{" "}
          <Link to="/" className="text-blue-500 hover:text-blue-600">
            Sign in here
          </Link>{" "}
        </p>
      </div>
    </div>
  );
};

export default SignUp;
